import React, { createContext, useContext } from 'react';
import { PageLocation } from '../model';

interface DashboardContextType {
  location: PageLocation;
}

const DashboardContext = createContext<DashboardContextType | undefined>(
  undefined,
);

export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  return context;
};

interface DashboardProviderProps {
  children: React.ReactNode;
  location: PageLocation;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({
  children,
  location,
}) => {
  return (
    <DashboardContext.Provider value={{ location }}>
      {children}
    </DashboardContext.Provider>
  );
};
